var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { CONFIG } from "@/config";
import { atom } from "jotai";
import { useAtomValue, useUpdateAtom } from "jotai/utils";
import { useCallback } from "react";
import { Quaternion, Vector3 } from "three";
var CameraAtomData = atom({
    intro: {
        triggered: false,
        progress: 0,
        complete: false,
    },
    position: new Vector3(),
    rotation: new Quaternion(),
});
export var CameraAtom = atom(function (get) { return get(CameraAtomData); }, function (get, set, update) {
    switch (update.action) {
        case "triggerIntro":
            set(CameraAtomData, function (camera) { return (__assign(__assign({}, camera), { intro: __assign(__assign({}, camera.intro), { triggered: true }) })); });
            return;
        case "progressIntro":
            set(CameraAtomData, function (camera) { return (__assign(__assign({}, camera), { intro: __assign(__assign({}, camera.intro), { progress: update.progress, complete: update.progress >= 1 }) })); });
            return;
        case "move":
            set(CameraAtomData, function (camera) { return (__assign(__assign({}, camera), { position: update.position, rotation: update.rotation })); });
            return;
        default:
            // Those lines ensure the typing that all actions are handled
            var missingCase = update;
            throw missingCase;
    }
});
export var CameraIntroComplete = atom(function (get) { return get(CameraAtomData).intro.complete; });
export var Zoom = atom(function (get) {
    return get(CameraTarget).zoom;
}, function (get, set, zoom) {
    set(CameraTarget, function (prev) { return (__assign(__assign({}, prev), { zoom: zoom })); });
});
var VELOCITY = 0.1;
export var useMoveCamera = function () {
    var setCameraTarget = useUpdateAtom(CameraTarget);
    return useCallback(function (direction) {
        var horizontal = ["right", "left"].includes(direction)
            ? VELOCITY * (direction === "right" ? 1 : -1)
            : 0;
        var vertical = ["up", "down"].includes(direction)
            ? VELOCITY * (direction === "down" ? 1 : -1)
            : 0;
        setCameraTarget(function (prev) { return (__assign(__assign({}, prev), { hPos: prev.hPos + horizontal, vPos: prev.vPos + vertical })); });
    }, [setCameraTarget]);
};
export var CameraTarget = atom({
    hPos: CONFIG.models.initialCameraPosition.x,
    vPos: CONFIG.models.initialCameraPosition.y,
    zoom: CONFIG.models.initialCameraPosition.zoom,
});
/** Detect if user has been interacting with camera */
var CameraMovedAtom = atom(function (get) {
    var target = get(CameraTarget);
    return (target.hPos !== CONFIG.models.initialCameraPosition.x ||
        target.vPos !== CONFIG.models.initialCameraPosition.y ||
        target.zoom !== CONFIG.models.initialCameraPosition.zoom);
});
export var useCameraMoved = function () {
    return useAtomValue(CameraMovedAtom);
};
